var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeals(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_333_7423)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M11.4496 5.26778L10.0265 6.46868C9.7025 6.74263 9.30669 6.87606 8.91353 6.87606C8.42334 6.87606 7.93711 6.66834 7.5957 6.26518C6.97901 5.50868 7.07245 4.45159 7.79839 3.83676L11.7623 0.568426L10.0948 0.255615C8.03558 0.268919 6.0662 1.09984 4.60714 2.55316L3.44995 2.56754V10.6071L5.25581 10.6039L8.50815 13.5457C9.49644 14.3493 10.9429 14.1965 11.7425 13.2133L12.3937 13.7613C12.9644 14.228 13.8089 14.1381 14.2761 13.5681L15.4038 12.1803L15.597 12.342C16.0911 12.7371 16.8145 12.6653 17.2142 12.1713L17.5569 11.7477C17.9551 11.2555 17.8798 10.5314 17.3882 10.1323L11.4496 5.26778ZM19.55 2.57113V10.6107C19.55 11.2435 20.0621 11.7631 20.6676 11.7631L23 11.7613V2.57473L19.55 2.57113ZM21.275 10.6107C20.9605 10.6107 20.7 10.3499 20.7 10.0358C20.7 9.71695 20.9605 9.46088 21.275 9.46088C21.5894 9.46088 21.85 9.71703 21.85 10.0358C21.85 10.3519 21.5912 10.6107 21.275 10.6107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.25 2.56406C15.7773 1.09241 14.9284 0.258608 12.8441 0.258608C12.4671 0.258608 12.1278 0.236528 11.7588 0.566601L7.79844 3.83688C7.0725 4.45171 6.97906 5.50879 7.59719 6.26745C7.93859 6.67051 8.42483 6.87833 8.91502 6.87833C9.30817 6.87833 9.70384 6.74472 10.028 6.47096L11.45 5.26789L17.3905 10.1326C17.5472 10.2598 17.6465 10.4265 17.7168 10.6015L19.55 10.5785V2.57125L17.25 2.56406ZM0 11.7578L2.3 11.7593C2.93789 11.7593 3.45 11.2451 3.45 10.6076V2.56765H0V11.7578ZM1.725 9.46387C2.03945 9.46387 2.3 9.72002 2.3 10.0388C2.3 10.3529 2.03945 10.6137 1.725 10.6137C1.41055 10.6137 1.15 10.352 1.15 10.0392C1.15 9.71916 1.41055 9.46387 1.725 9.46387Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_333_7423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeals);
export default __webpack_public_path__ + "static/media/deals.52c79f1f82d4e44f633b3b3665c57bf3.svg";
export { ForwardRef as ReactComponent };